import { Button, Box, Stack, Text } from "@chakra-ui/react";
import React, { useState } from "react";
import { IApiLogs } from "@/types/common";
import BaseDialog from "../../BaseDialog";

const ViewResponseAndRequestDialogButton = ({
  field,
  isRequest = false,
}: {
  field: IApiLogs;
  isRequest?: boolean;
}) => {
  const [open, setOpen] = useState(false);
  return (
    <BaseDialog
      trigger={
        <p
          style={{
            color: "#E24F4B",
            cursor: "pointer",
          }}
        >
          Click to view
        </p>
      }
      title={isRequest ? "Request data" : "Response data"}
      actionButtons={
        <Button variant="outline" onClick={() => setOpen(false)}>
          Close
        </Button>
      }
      open={open}
      setOpen={setOpen}
    >
      <Stack
        maxH="60vh"
        overflow="auto"
        mt="30px"
        border="1px solid"
        borderColor="#E1E1E1"
        borderRadius="8px"
        p="10px"
      >
        <Box
          as="pre"
          fontFamily="Inter"
          fontSize="14px"
          m={0}
          fontWeight={400}
          color="#323232"
          whiteSpace="pre-wrap"
          wordBreak="break-word"
          overflowWrap="anywhere"
        >
          {isRequest
            ? JSON.stringify(field?.request, null, 2)
            : field?.response
              ? JSON.stringify(field?.response, null, 2)
              : " "}
        </Box>
      </Stack>
    </BaseDialog>
  );
};
export default ViewResponseAndRequestDialogButton;
